import React from 'react';

import AppProvider from './context/AppProvider';
import PageLoad from './components/load/PageLoad';
import Container from './components/container/Container';
import Banner from  './components/banner/Banner';
import Header from './components/header/Header';
import BoxContent from './components/content/BoxContent';
import FriendContent from './components/friend/FriendContent';
import SimpleSlider from './components/slider/SimpleSlider';

const App = () => {

  
  return (
    <AppProvider>
      <div className="App">
      <PageLoad />
      <Container>
        <Banner />
        <Header />
        <BoxContent />
        <FriendContent>
          <SimpleSlider />
        </FriendContent>
      </Container>
    </div>
    </AppProvider>
  );
}

export default App;